<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Clipboard } from '@client/components/clipboard';
  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';

  import { AssetsService } from '@client/services/assets';

  import { appStore } from '@client/stores/app';

  export let row = {};
  export let props = {};

  const navigate = useNavigate();
  const redirect = (path) => navigate(path);

  const { addNotification } = getNotificationsContext();

  let isOpen = false;

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const onRenameHandler = () => {
    if (props.onRename) {
      props.onRename(row);
    }
  };

  const onDeleteHandler = async () => {
    const confirmed = confirm(
      $format('label.DELETE_PROMPT', { values: { type: $format('label.VIDEO').toLowerCase() } })
    );

    if (confirmed) {
      $appStore.loading = true;

      const response = await AssetsService.deleteVideo(row);

      $appStore.loading = false;

      if (response?.status >= 400) {
        notify($format('label.FAILURE.RULENAME_DELETE', { values: { rulename: row.rulename } }), 'error');
        return;
      }

      notify($format('label.SUCCESS.DELETE', { values: { type: row.rulename } }));

      props.onDelete();
    }
  };
</script>

<ButtonDropdown bind:isOpen>
  <DropdownToggle color="none" tag="span">
    <Icon name="more-vertical" class={isOpen ? 'action-icon active' : 'action-icon'} />
  </DropdownToggle>
  <DropdownMenu>
    {#if props.onRename}
      <DropdownItem on:click={onRenameHandler}>{$format('label.RENAME')}</DropdownItem>
      <DropdownItem divider />
    {/if}
    <DropdownItem on:click={() => redirect(row.rulename)}>{$format('label.EDIT')}</DropdownItem>
    <DropdownItem divider />
    <Clipboard text="[[vid:{row.rulename}]]" let:copy>
      <DropdownItem on:click={copy}>{$format('label.COPY_RULE')}</DropdownItem>
    </Clipboard>
    <DropdownItem divider />
    <DropdownItem on:click={onDeleteHandler}>{$format('label.DELETE')}</DropdownItem>
  </DropdownMenu>
</ButtonDropdown>

<style lang="scss">
  i {
    border: 1px solid transparent;
    border-radius: var(--border-radius-base);
    color: var(--color-text);
    cursor: pointer;
    padding: var(--padding-small) var(--padding-xsmall);

    &.active,
    &:hover {
      background-color: var(--color-white);
      border-color: var(--color-gray-200);
    }
  }
</style>
